<template>
  <dialog-scroll-lock width="300" :value="true" @input="$emit('close')">
    <v-card>
      <v-btn class="ma-3" style="right: 0;" absolute icon @click="$emit('close')">
        <v-icon v-html="mdiClose" />
      </v-btn>
      <v-card-title>Options</v-card-title>
      <v-divider />
      <v-card-text class="pt-5">
        <canvas ref="canvas" class="d-block mx-auto" style="width: 144px; height: 144px;" width="288" height="288" />
        <v-checkbox hide-details label="Scale to fit" :disabled="opts.w == opts.h" v-model="opts.scale" />
        <v-checkbox hide-details label="Add border" v-model="opts.border" />
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="$emit('close')">Cancel</v-btn>
        <v-spacer />
        <v-btn
          text color="primary"
          :disabled="loadImgStatus.pending"
          :loading="saveStatus.pending"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </dialog-scroll-lock>
</template>

<script>
import stampMask from '@/assets/stamp-mask.png';
import { mdiClose } from '@mdi/js';


const W = 288;
const W_MASK = 216;
const MASK_OFFSET = (W - W_MASK) / 2;
const MASK = new Promise(r => {
  const img = new Image();
  img.onload = () => r(img);
  img.src = stampMask;
});


export default {
  name: 'custom-stamp-prompt',

  props: [ 'opts' ],

  data() {
    return {
      staged: '#FFFFFF',
      loadImgStatus: this.$track('loadImg'),
      saveStatus: this.$track('save')
    };
  },

  created() {
    Object.assign(this, { mdiClose });
  },

  methods: {
    async loadImg(src) {
      return await new Promise(
        r => {
          const img = new Image();
          img.onload = () => r(img);
          img.src = src;
        }
      );
    },

    async save() {
      const url = await new Promise(r => this.$emit('save', this.$refs.canvas.toDataURL('image/png'), r));
      this.$emit('input', url);
      this.$emit('close');
    }
  },

  watch: {
    opts: {
      deep: true,
      immediate: true,
      async handler(v) {
        await this.$nextTick();
        const img = await this.loadImg(v.url);
        const canvas = this.$refs.canvas;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, W, W);
        const w = v.border ? W_MASK : W;
        const offset = v.border ? MASK_OFFSET : 0;
        if (v.border) {
          ctx.fillStyle = 'white';
          ctx.fillRect(offset - 4, offset - 4, w + 8, w + 8);
        }
        if (v.scale) {
          const s = Math.min(img.width, img.height);
          const sx = (img.width - s) / 2;
          const sy = (img.height - s) / 2;
          ctx.drawImage(img, sx, sy, s, s, offset, offset, w, w);
        } else {
          const r = img.width / img.height;
          if (r > 1)
            ctx.drawImage(img, offset, offset + (w - (w / r)) / 2, w, w / r);
          else
            ctx.drawImage(img, offset + (w - (w * r)) / 2, offset, w * r, w);
        }
        if (v.border) {
          const mask = await MASK;
          ctx.drawImage(mask, 0, 0, W, W);
        }
      }
    }
  }
}
</script>
